import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '@core/config/constants';
import { useAuth } from '@features/auth/context/AuthContext';

import { FaHeart, FaShoppingBag, FaBars, FaTimes } from 'react-icons/fa';
import logoImage from '@assets/logo/logo.png';
import './Header.css';

export const Header = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isHomePage = location.pathname === ROUTES.HOME;

  const handleLogout = async () => {
    await logout();
    setIsMobileMenuOpen(false);
  };

  const handleHomeClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isHomePage ? 'header--sticky' : 'header--static'}`}>
      <div className="header__container">
        <Link
          to={ROUTES.HOME}
          className="header__logo"
          onClick={handleHomeClick}
        >
          <img src={logoImage} alt="Logo" className="header__logo-image" />
          <span className="header__logo-text">AR Boutique</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="header__nav">
          <Link
            to={ROUTES.HOME}
            className="header__nav-link"
            onClick={handleHomeClick}
          >
            Home
          </Link>
          <Link to={ROUTES.PRODUCTS} className="header__nav-link">
            Shop
          </Link>
          <Link to={ROUTES.CATEGORIES} className="header__nav-link">
            Categories
          </Link>
        </nav>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <>
            <div
              className="header__overlay"
              onClick={() => setIsMobileMenuOpen(false)}
            />
            <nav className="header__mobile-nav">
              <Link
                to={ROUTES.HOME}
                className="header__mobile-nav-link"
                onClick={handleNavClick}
              >
                Home
              </Link>
              <Link
                to={ROUTES.PRODUCTS}
                className="header__mobile-nav-link"
                onClick={handleNavClick}
              >
                Shop
              </Link>
              <Link
                to={ROUTES.CATEGORIES}
                className="header__mobile-nav-link"
                onClick={handleNavClick}
              >
                Categories
              </Link>
              <div className="header__mobile-divider" />
              {user ? (
                <button
                  className="header__mobile-nav-link header__mobile-logout"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              ) : (
                <Link
                  to={ROUTES.LOGIN}
                  className="header__mobile-nav-link"
                  onClick={handleNavClick}
                >
                  Login
                </Link>
              )}
            </nav>
          </>
        )}

        <div className="header__actions">
          <Link
            to="/wishlist"
            className="header__action-icon header__wishlist"
            style={{ position: 'relative' }}
            aria-label="Wishlist"
          >
            <FaHeart size={20} />
          </Link>

          <Link
            to={ROUTES.CART}
            className="header__action-icon header__cart"
            aria-label="Shopping Cart"
          >
            <FaShoppingBag size={20} />
          </Link>

          {user ? (
            <div className="header__user-actions">
              <Link to={ROUTES.ACCOUNT} className="header__login-btn">
                Account
              </Link>
            </div>
          ) : (
            <Link to={ROUTES.LOGIN} className="header__login-btn">
              Login
            </Link>
          )}

          {/* Mobile Menu Toggle Button */}
          <button
            className="header__mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>
    </header>
  );
};
